import { CloudArrowUpIcon, LockClosedIcon, ServerIcon } from '@heroicons/react/20/solid'
import critical from '../../assets/critical.jpg'
import { FiArrowDownCircle } from 'react-icons/fi'
import CriticalApply from '../../assets/CriticalApply.pdf'
import CriticalClaim from '../../assets/CriticalClaim.pdf'
import { Link } from 'react-router-dom'

export default function CriticalIllness() {
  return (
    <div className="relative isolate overflow-hidden bg-white px-6 py-24 sm:py-32 lg:overflow-visible lg:px-0">
      <div className="absolute inset-0 -z-10 overflow-hidden">
        <svg
          className="absolute left-[max(50%,25rem)] top-0 h-[64rem] w-[128rem] -translate-x-1/2 stroke-gray-200 [mask-image:radial-gradient(64rem_64rem_at_top,white,transparent)]"
          aria-hidden="true"
        >
          <defs>
            <pattern
              id="e813992c-7d03-4cc4-a2bd-151760b470a0"
              width={200}
              height={200}
              x="50%"
              y={-1}
              patternUnits="userSpaceOnUse"
            >
              <path d="M100 200V.5M.5 .5H200" fill="none" />
            </pattern>
          </defs>
          <svg x="50%" y={-1} className="overflow-visible fill-gray-50">
            <path
              d="M-100.5 0h201v201h-201Z M699.5 0h201v201h-201Z M499.5 400h201v201h-201Z M-300.5 600h201v201h-201Z"
              strokeWidth={0}
            />
          </svg>
          <rect width="100%" height="100%" strokeWidth={0} fill="url(#e813992c-7d03-4cc4-a2bd-151760b470a0)" />
        </svg>
      </div>
      <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 lg:mx-0 lg:max-w-none lg:grid-cols-2 lg:items-start lg:gap-y-10">
        <div className="lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8">
          <div className="lg:pr-4">
            <div className="lg:max-w-lg">
              <p className="text-base font-semibold leading-7 text-indigo-600">Insurance</p>
              <h1 className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Critical Illness Cover</h1>
              <p className="mt-6 text-xl leading-8 text-gray-700">
              The Britam Critical Illness Plan is a protection cover designed to provide an extra layer of financial security in the event that one is diagnosed with Critical illness.
              </p>
            </div>
          </div>
        </div>
        <div className="-ml-12 -mt-12 p-12 lg:sticky lg:top-4 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:overflow-hidden">
          <img
            className="w-[48rem] max-w-none rounded-xl bg-gray-900 shadow-xl ring-1 ring-gray-400/10 sm:w-[57rem]"
            src={critical}
            alt=""
          />
          <div className='flex gap-x-4'>
          <a
            download={CriticalApply}
            href={CriticalApply}
            className="font-general-medium flex justify-center items-center w-36 sm:w-48 mt-12 mb-6 sm:mb-0 text-lg border border-indigo-200 dark:border-ternary-dark py-2.5 sm:py-3 shadow-lg rounded-lg bg-indigo-50 focus:ring-1 focus:ring-indigo-900 hover:bg-indigo-500 text-gray-500 hover:text-white duration-500"
            aria-label="Download Resume"
          >
            <FiArrowDownCircle className="mr-2 sm:mr-3 h-5 w-5 sn:w-6 sm:h-6 duration-100"></FiArrowDownCircle>
            <span className="text-sm sm:text-lg font-general-medium duration-100">
              Application Form
            </span>
          </a>
          <a
          href={CriticalClaim}
            download={CriticalClaim}
            
            className="font-general-medium flex justify-center items-center w-36 sm:w-48 mt-12 mb-6 sm:mb-0 text-lg border border-indigo-200 dark:border-ternary-dark py-2.5 sm:py-3 shadow-lg rounded-lg bg-indigo-50 focus:ring-1 focus:ring-indigo-900 hover:bg-indigo-500 text-gray-500 hover:text-white duration-500"
            aria-label="Download Resume"
          >
            <FiArrowDownCircle className="mr-2 sm:mr-3 h-5 w-5 sn:w-6 sm:h-6 duration-100"></FiArrowDownCircle>
            <span className="text-sm sm:text-lg font-general-medium duration-100">
              Claim Form
            </span>
          </a>
          </div>
        </div>
        <div className="lg:col-span-2 lg:col-start-1 lg:row-start-2 lg:mx-auto lg:grid lg:w-full lg:max-w-7xl lg:grid-cols-2 lg:gap-x-8 lg:px-8">
          <div className="lg:pr-4">
            <div className="max-w-xl text-base leading-7 text-gray-700 lg:max-w-lg">
            
              <ul role="list" className="mt-8 space-y-8 text-gray-600">
                <li className="flex gap-x-3">
                  <span>
                    <strong className="font-semibold text-gray-900">About Britam Critical Illness Cover</strong> <br/>
                    The Britam Critical Illness Plan covers a comprehensive list of illnesses namely Heart Attack, Stroke, Cancer, Kidney failure, Coronary artery bypasses surgery, Aortic Surgery, Heart Valve Surgery, Major organ transplant, Paraplegia, Coma, Blindness, Multiple Sclerosis, Accidental Brain Damage, Motor Neuron Disease, Dementia (including Alzheimer’s and Parkinson’s disease)
                    <br/><br/>The amount of premium one pays will depend on age and the amount of the sum assured ( that is a chosen benefit).
                    <br/><br/>The premiums are affordable and are payable in a flexible way; monthly, quarterly, semi-annually or annually.
                    <br/><br/>Various premium payment options are available e.g. Employer salary check-off, direct debit, personal cheques or mobile money transfer.
                    <br/><br/>Britam will pay a lump sum amount equal to the sum assured in the event one is diagnosed with any of the defined critical illnesses.
                    <br/><br/>This policy gives you access to personalized service by Britam
                  </span>
                </li>

                <li className="flex gap-x-3">
                  <span>
                    <strong className="font-semibold text-gray-900">Why you need the Britam Critical Illness Cover?</strong> <br/>
                    Critical illnesses have recently become prevalent.                    
                    <br/><br/>Many times, Critical Illnesses hit the family’s breadwinners hence affecting families financially and disabling the lifestyle a unit is used to.
                    <br/><br/>The premiums are affordable and are payable in a flexible way; monthly, quarterly, semi-annually or annually.
                    <br/><br/>However, more people are now surviving critical illnesses due to advanced medical science and improved hospital care. The outcome of a major health crisis is more likely to be survival than death.This means that more people need financial support during recovery and thus the reason you need the Britam Critical Illness Plan.
                    <br/><br/>Sufficient protection against the financial shocks brought about by critical illnesses requires more than a usual life insurance cover.
                  </span>
                </li>

              </ul>
        
              <h2 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">Who is Britam Critical Illness Cover for?</h2>
              <p className="mt-6">
              Any Kenyan Citizen aged 18-60 is eligible to apply and take this cover.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
